export default __webpack_public_path__ + "static/media/targetTimer.2b3818a0.svg";